import { render } from "./addstore.vue?vue&type=template&id=6995f5d4"
import script from "./addstore.vue?vue&type=script&lang=js"
export * from "./addstore.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__